// api/authAPI.ts

import apiClient from './apiClient';
import { CashTx } from '../types/CashTx';
import constants from '../constants';
import { CreateCashTxType } from '../stores/cashTxStore';
import { Cash } from '../types/Cash';
import {CashPeriodDataInterface, CashPeriodSumDataInterface} from "../containers/CashPeriod/CashPeriod.interface";

const fetchCashRequestAPI = async ({
	page,
	userId,
	amount,
	reason,
  status,
	limit = constants.PAGE_SIZE,
                                   }: {
	page: number;
	userId?: string;
	amount?: number | null
	reason?: string;
  status?: string;
	limit: number;
}) : Promise<CashTx[]> => {
  const offset = (page - 1) * limit;
  const response = await apiClient.get('/api/admin/business/cash/request/txs', {
    params: { offset, limit, userId, amount, reason, status }
  });
  return response.data;
}

const fetchCashPeriodRequestAPI = async ({ page, limit = constants.PAGE_SIZE, fromDate, toDate }
                                         : {page: number, limit: number, fromDate?: string, toDate?: string }) : Promise<CashPeriodDataInterface[]> => {
  const offset = (page - 1) * limit;
  const response = await apiClient.get('/api/admin/business/cash/request/txs/period', {
    params: { offset, limit, fromDate, toDate }
  });
  return response.data;
}

const fetchCashPeriodSumRequestAPI = async ({ fromDate, toDate, reasonCodeList }: {fromDate?: string, toDate?: string, reasonCodeList?: string[]}) : Promise<CashPeriodSumDataInterface> => {
  const response = await apiClient.get('/api/admin/business/cash/request/txs/period/sum', {
    params: { fromDate, toDate, reasonCodeList }
  });
  return response.data;
}

const fetchCashAPI = async (userId: string) : Promise<Cash> => {
  const response = await apiClient.get(`/api/admin/business/cash`, {
    params: { userId }
  });
  return response.data as Cash;
}

const fetchAllUserCashTotalAPI = async () : Promise<{ allUserCashTotal: number, firstBaljuTotal: number, testUserTotal: number }> => {
  const response = await apiClient.get(`/api/admin/business/cash/total`);
  return response.data;
}

const confirmCashRequestAPI = async (cashTxId: string, cashTxDTO: CashTx | null) : Promise<CashTx> => {
  const response = await apiClient.put(`/api/admin/business/cash/request/confirm`, { cashTxId, cashTxDTO });
  return response.data as CashTx;
}

const rejectCashRequestAPI = async (cashTxId: string, cashTxDTO: CashTx | null) : Promise<CashTx> => {
  const response = await apiClient.put(`/api/admin/business/cash/request/cancel`, { cashTxId, cashTxDTO });
  return response.data;
}

export const createDepositRequestAPI = async ( createCashTx: CreateCashTxType) : Promise<CashTx> => {
  const response = await apiClient.post(`/api/admin/business/cash/request/deposit`, createCashTx);
  return response.data;
}

const createWithdrawRequestAPI = async ({ amount, reason, userId, accountBank, accountName, accountNumber }: {
  amount: number,
  reason: string,
  userId: string,
  accountBank?: string,
  accountName?: string,
  accountNumber?: string
}) : Promise<void> => {

  if (accountBank === undefined || accountName === undefined || accountNumber === undefined) throw new Error();
 const response = await apiClient.post(`/api/admin/business/cash/request/withdrawal`, { amount, reason, userId, accountBank, accountName, accountNumber });
  return response.data;
}

const cashTxAPI = {
  fetchCashRequestAPI,
  fetchCashAPI,
  fetchAllUserCashTotalAPI,
  confirmCashRequestAPI,
  rejectCashRequestAPI,
  createDepositRequestAPI,
  createWithdrawRequestAPI,
  fetchCashPeriodRequestAPI,
  fetchCashPeriodSumRequestAPI,
};

export default cashTxAPI;
